export enum PaymentProviderEnum {
  CREDIT_CARD = 'Credit Card',
  PAYPAL = 'Paypal',
  BRAINTREE = 'Braintree',
  SOFORT = 'Sofort Überweisung',
  GIROPAY = 'Giropay',
}
